export class AsyncHelper {
  public static delay(time): Promise<{}> {
    return new Promise((res) => setTimeout(() => res(null), time));
  }
  public static async waitUntilTrueAsync(
    condition: () => boolean,
    successCallback: () => void = undefined,
    failCallback: () => void = undefined,
  ): Promise<void> {
    if (!condition) {
      throw new Error('condition is undefined');
    }
    let count = 6000;
    let result = condition();
    while (count-- && !result) {
      await this.delay(10);
      result = condition();
    }
    if (result) {
      if (successCallback) {
        successCallback();
      } else {
        Promise.resolve();
      }
    } else {
      if (failCallback) {
        failCallback();
      } else {
        Promise.reject('Value has never been true');
      }
    }
  }
}
